export const videoBtnDataSet = { cy: 'createIntroButtons-video-btn' };

export const galleryBtnDataSet = { cy: 'createIntroButtons-gallery-btn' };

export const importBtnDataSet = { cy: 'createIntroButtons-import-btn' };
